(function () {
  var messages = {
    success: {
      type: 'success',
      text: 'Trial extension deposited. Please check your iLok account; it may take a few minutes to appear in iLok License Manager.'
    },
    invalid_ilok_user: {
      type: 'error',
      text: 'The iLok User ID "[ILOK-USERNAME]" does not exist. Please check the spelling and try again.',
      link: {
        text: 'Learn more.',
        href: 'https://support.mixwave.com/help/ilok-and-ilok-license-manager#locating-your-ilok-user-id'
      }
    },
    no_trial_found: {
      type: 'error',
      text: 'We could not find an original trial for [PLUGIN-NAME] in the iLok account [ILOK-USERNAME]. Please start a trial before requesting an extension.',
      link: {
        text: 'Learn more.',
        href: 'https://support.mixwave.com/help/starting-a-plugin-free-trial'
      }
    },
    trial_still_active: {
      type: 'info',
      text: 'An original trial for [PLUGIN-NAME] is already in the iLok account [ILOK-USERNAME] and has not expired. If it has not yet been activated, activate it in iLok License Manager. Trial extensions are only available after the original trial expires.'
    },
    extension_pending_activation: {
      type: 'info',
      text: 'The iLok account [ILOK-USERNAME] already has a trial extension for [PLUGIN-NAME]. Use the iLok License Manager application to activate the trial before using the plug-in.'
    },
    extension_already_used: {
      type: 'error',
      text: 'A trial extension has already been issued for [PLUGIN-NAME]. Only one extension is available per plug-in.'
    },
    request_in_progress: {
      type: 'info',
      text: 'This trial extension request is already being processed. Please wait a moment before trying again.'
    },
    already_licensed: {
      type: 'info',
      text: 'The iLok account [ILOK-USERNAME] already has a full license for [PLUGIN-NAME], so a trial extension is not needed.'
    },
    plugin_not_configured: {
      type: 'error',
      text: 'Trial extensions are not available for the selected plug-in at this time.'
    },
    service_unavailable: {
      type: 'error',
      text: 'We could not process the request right now. Please wait a moment and try again.'
    },
    rate_limited: {
      type: 'error',
      text: 'Too many attempts were submitted in a short period. Please wait a few minutes and try again.'
    },
    invalid_request: {
      type: 'error',
      text: 'Please complete the form and try again.'
    },
    turnstile_failed: {
      type: 'error',
      text: 'The bot check did not complete. Please refresh the page and try again.'
    },
    endpoint_missing: {
      type: 'error',
      text: 'This form is not configured yet.'
    },
    network_error: {
      type: 'error',
      text: 'The request could not reach iLok services. Please wait a few minutes and try again.'
    }
  };

  function getMessageContext(form) {
    var product = form.querySelector('[name="productHandle"]');
    var ilok = form.querySelector('[name="ilokUserId"]');
    var selectedOption = product && product.options ? product.options[product.selectedIndex] : null;

    return {
      ilokUserId: ilok && ilok.value ? ilok.value.trim() : '',
      pluginName: selectedOption && selectedOption.value ? selectedOption.text.trim() : 'this plugin'
    };
  }

  function formatMessageText(text, context) {
    return String(text || '')
      .replace(/\[ILOK-USERNAME\]/g, context.ilokUserId || 'this iLok account')
      .replace(/\[PLUGIN-NAME\]/g, context.pluginName || 'this plugin');
  }

  function setMessage(form, status, fallback) {
    var el = form.querySelector('[data-status-message]');
    if (!el) return;
    var context = getMessageContext(form);

    var config = messages[status] || {
      type: 'error',
      text: fallback || 'Something went wrong. Please try again.'
    };

    el.className = 'mw-trial-extension__message is-' + config.type;
    el.textContent = formatMessageText(config.text, context);

    if (config.link && config.link.href && config.link.text) {
      el.appendChild(document.createTextNode(' '));

      var link = document.createElement('a');
      link.href = config.link.href;
      link.textContent = config.link.text;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      el.appendChild(link);
    }

    el.hidden = false;
  }

  function clearMessage(form) {
    var el = form.querySelector('[data-status-message]');
    if (!el) return;
    el.hidden = true;
    el.textContent = '';
    el.className = 'mw-trial-extension__message';
  }

  function getTurnstileToken(form) {
    var responseInput = form.querySelector('input[name="cf-turnstile-response"]');
    return responseInput ? responseInput.value : '';
  }

  function resetTurnstile() {
    if (window.turnstile && typeof window.turnstile.reset === 'function') {
      window.turnstile.reset();
    }
  }

  function setLoading(button, isLoading) {
    if (!button) return;
    button.disabled = isLoading;
    button.textContent = isLoading ? 'Checking...' : 'Submit';
  }

  var CATALOG_URL = 'https://api.mixwave.com/website/downloads';

  function catalogProducts(body) {
    if (!body || body.schemaVersion !== 1 || !Array.isArray(body.products) || body.products.length > 1000) {
      throw new Error('invalid_catalog');
    }
    var handles = new Set();
    return body.products.filter(function (product) {
      return product && product.trialExtensionEligible === true && product.productType === 'plugin'
        && product.isCollection !== true && product.children == null
        && !Object.prototype.hasOwnProperty.call(product, 'primaryChild')
        && !Object.prototype.hasOwnProperty.call(product, 'groupOwnershipMode');
    }).map(function (product) {
      if (typeof product.productHandle !== 'string' || product.productHandle.length > 120
        || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(product.productHandle)
        || typeof product.productName !== 'string' || !product.productName.trim()
        || product.productName.length > 200 || /[\u0000-\u001f\u007f-\u009f]/.test(product.productName)
        || handles.has(product.productHandle)) throw new Error('invalid_catalog_product');
      handles.add(product.productHandle);
      return { handle: product.productHandle, name: product.productName.trim() };
    }).sort(function (left, right) {
      return left.name.localeCompare(right.name, undefined, { sensitivity: 'base' })
        || left.handle.localeCompare(right.handle);
    });
  }

  function placeholder(select, label) {
    select.textContent = '';
    var option = document.createElement('option');
    option.value = '';
    option.textContent = label;
    option.disabled = true;
    option.defaultSelected = true;
    option.selected = true;
    select.appendChild(option);
  }

  function validate(form) {
    var product = form.querySelector('[name="productHandle"]');
    var ilok = form.querySelector('[name="ilokUserId"]');
    var token = getTurnstileToken(form);
    var valid = true;

    [product, ilok].forEach(function (field) {
      if (field) field.classList.remove('is-error');
    });

    if (!product || !product.value) {
      if (product) product.classList.add('is-error');
      valid = false;
    }

    if (!ilok || !ilok.value.trim()) {
      if (ilok) ilok.classList.add('is-error');
      valid = false;
    }

    if (!valid) return { ok: false, status: 'invalid_request' };
    if (!token) return { ok: false, status: 'turnstile_failed' };

    return {
      ok: true,
      payload: {
        productHandle: product.value,
        ilokUserId: ilok.value.trim(),
        turnstileToken: token
      }
    };
  }

  function initForm(form) {
    if (!form || form.dataset.mwTrialExtensionReady === 'true') return;
    form.dataset.mwTrialExtensionReady = 'true';

    var endpoint = form.getAttribute('data-endpoint') || '';
    var button = form.querySelector('button[type="submit"]');
    var product = form.querySelector('[name="productHandle"]');
    var catalogStatus = form.querySelector('[data-catalog-status]');
    var retry = form.querySelector('[data-catalog-retry]');
    var catalogReady = false;
    var catalogLoading = false;
    var submitting = false;

    function loadProducts() {
      if (catalogLoading || submitting || !product) return;
      catalogLoading = true;
      catalogReady = false;
      form.dataset.mwTrialExtensionProducts = 'loading';
      product.disabled = true;
      product.setAttribute('aria-busy', 'true');
      if (button) button.disabled = true;
      if (retry) retry.hidden = true;
      if (catalogStatus) catalogStatus.textContent = 'Loading plugins…';
      placeholder(product, 'Loading plugins…');
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 15000);
      fetch(CATALOG_URL, { method: 'GET', credentials: 'omit', cache: 'no-store', signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('catalog_unavailable');
          return response.json();
        })
        .then(catalogProducts)
        .then(function (products) {
          placeholder(product, products.length ? 'Select a product' : 'No plugins available');
          products.forEach(function (entry) {
            var option = document.createElement('option');
            option.value = entry.handle;
            option.textContent = entry.name;
            product.appendChild(option);
          });
          catalogReady = products.length > 0;
          form.dataset.mwTrialExtensionProducts = catalogReady ? 'ready' : 'empty';
          product.disabled = !catalogReady;
          if (button) button.disabled = !catalogReady;
          if (catalogStatus) catalogStatus.textContent = catalogReady ? '' : 'No plugins are currently available for trial extensions.';
          if (retry) retry.hidden = catalogReady;
        })
        .catch(function () {
          form.dataset.mwTrialExtensionProducts = 'error';
          placeholder(product, 'Plugins unavailable');
          if (catalogStatus) catalogStatus.textContent = 'Unable to load plugins. Please try again.';
          if (retry) retry.hidden = false;
        })
        .finally(function () {
          clearTimeout(timeout);
          catalogLoading = false;
          product.removeAttribute('aria-busy');
        });
    }

    if (retry) retry.addEventListener('click', loadProducts);
    loadProducts();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!catalogReady || submitting) return;
      clearMessage(form);

      if (!endpoint) {
        setMessage(form, 'endpoint_missing');
        return;
      }

      var result = validate(form);
      if (!result.ok) {
        setMessage(form, result.status);
        return;
      }

      submitting = true;
      setLoading(button, true);

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(result.payload)
      })
        .then(function (response) {
          return response.json().catch(function () {
            return {};
          }).then(function (body) {
            return { ok: response.ok, status: response.status, body: body };
          });
        })
        .then(function (result) {
          var status = result.body && result.body.status ? result.body.status : 'service_unavailable';
          setMessage(form, status, result.body && result.body.message);

          if (status === 'success') {
            form.reset();
          }
        })
        .catch(function () {
          setMessage(form, 'network_error');
        })
        .finally(function () {
          submitting = false;
          setLoading(button, false);
          resetTurnstile();
        });
    });
  }

  function initForms(root) {
    root.querySelectorAll('[data-mw-trial-extension] form').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initForms(document); });
  } else {
    initForms(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initForms(event.target); });
})();
